/**
 * Print-optimized color palette for PDF generation.
 * These hex colors are chosen to reproduce well in CMYK print.
 *
 * Note: @react-pdf/renderer only supports hex, rgb, rgba formats.
 * CMYK conversion happens at print time by the printer driver.
 */

/**
 * Pre-defined colors for PDF generation.
 * Colors are optimized hex values that print well.
 */
export const pdfColors = {
    // Text colors
    blackShark: '#21282D', // Main text color
    greyShuttle: '#576975', // Secondary text

    // Border/divider colors
    greyMist: '#B7CAD7', // Borders and dividers
    greyNepal: '#99B1C2',
    greyAsh: '#DBE4EB',

    // Status colors - main
    redPersian: '#D32E2F', // Poor status
    greenBiosphere: '#4BC682', // Good status
    yellowSunlight: '#FFC000', // Fair status

    // Status pill backgrounds (light versions)
    redLightBg: '#FBEBED', // Poor pill background
    greenLightBg: '#DCF4E6', // Good pill background
    yellowLightBg: '#FFECB2', // Fair pill background

    // Status pill text colors
    redDarkText: '#B72733', // Poor pill text
    greenDarkText: '#2D7C4C', // Good pill text
    yellowDarkText: '#B8860B', // Fair pill text

    // Misc
    white: '#FFFFFF',
    greyText: '#6B7280', // Footnote text
    greyPorcelain: '#F1F3F4',
    greyConcrete: '#F2F2F2',
    greyLightBg: '#F8F9FA', // Table header background
    greyLegendText: '#3D3D3D', // Legend range text
    greyFooter: '#8C9BA8', // Footer text
};

/**
 * Convert a status color to its PDF equivalent
 */
export const getStatusColorCmyk = (rgbColor: string): string => {
    const colorMap: Record<string, string> = {
        '#D32E2F': pdfColors.redPersian,
        '#4BC682': pdfColors.greenBiosphere,
        '#FFC000': pdfColors.yellowSunlight,
        '#B7CAD7': pdfColors.greyMist,
        '#21282D': pdfColors.blackShark,
    };

    const upperColor = rgbColor.toUpperCase();
    return colorMap[upperColor] || rgbColor;
};
